import { useFormContext } from "react-hook-form";

import {
  ELEMENT_WRAPPER_MB,
  ElementWrapper,
  HelpText,
  LabelCheckbox,
} from "@up/form";

export function CrossPartnerMarketingOptIn() {
  const { register } = useFormContext();
  const KEY = "cross-partner-marketing-opt-in";
  const registerProps = register(KEY);

  return (
    <ElementWrapper className={ELEMENT_WRAPPER_MB}>
      <HelpText>
        Our service provider Kaplan North America, LLC also works with other
        colleges and universities and offers education services. Would you like
        to learn about these?
      </HelpText>
      <LabelCheckbox Label="Yes, I agree to receive marketing emails about other education programs and services. I understand that I may unsubscribe at any time.">
        <input
          className="kup-checkbox"
          id={`${registerProps["name"]}`}
          type="checkbox"
          {...registerProps}
        />
      </LabelCheckbox>
    </ElementWrapper>
  );
}
